import {
  collection,
  getDocs,
  doc,
  updateDoc,
  query,
  where,
} from 'firebase/firestore';
import { db } from './config';

export const getFlags = async (status = 'pending') => {
  try {
    const q = query(collection(db, 'image_flags'), where('status', '==', status));
    const flagsSnapshot = await getDocs(q);
    const flags = flagsSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    return { success: true, flags };
  } catch (error) {
    console.error('Error getting flags:', error);
    return { success: false, error: error.message };
  }
};

export const updateFlagStatus = async (flagId, status) => {
  try {
    const flagRef = doc(db, 'image_flags', flagId);
    await updateDoc(flagRef, { status });
    return { success: true };
  } catch (error) {
    console.error('Error updating flag status:', error);
    return { success: false, error: error.message };
  }
};

export const approveCreditRequest = async (flag) => {
  try {
    const mediaRef = doc(db, 'site_media', flag.mediaId);
    await updateDoc(mediaRef, {
      credits: flag.details.creditData,
      creditProfileId: null, // Or create a new profile and link it
    });
    await updateFlagStatus(flag.id, 'resolved');
    return { success: true };
  } catch (error) {
    console.error('Error approving credit request:', error);
    return { success: false, error: error.message };
  }
};

export const takeDownImage = async (flag) => {
  try {
    const mediaRef = doc(db, 'site_media', flag.mediaId);
    await updateDoc(mediaRef, { dmcaStatus: 'taken_down' });
    await updateFlagStatus(flag.id, 'resolved');
    return { success: true };
  } catch (error) {
    console.error('Error taking down image:', error);
    return { success: false, error: error.message };
  }
};
